import { IsEnum, IsNotEmpty } from 'class-validator';
import { AllTokenVaultActions, TokenVaultActions } from './token-vault-actions.enum';
import { TokenVaultVerification } from './token-vault-verification.enum';

export class UserTwoFADto {
  @IsEnum(AllTokenVaultActions)
  @IsNotEmpty()
  action!: TokenVaultActions;

  @IsEnum(TokenVaultVerification)
  @IsNotEmpty()
  verification!: TokenVaultVerification;
}
